import React, { Component } from 'react';
import { Button, Col, Form, Input, Radio, Row, TreeSelect } from 'antd';
import { connect } from 'react-redux';

import {queryOrgInfo} from "@api/core/org";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class FormOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
    };
  }

  componentDidMount() {
    if (this.props.detail.uuid) {
      this.getDetail();
    }
  }

  getDetail = () => {
    queryOrgInfo({ uuid: this.props.detail.uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detail: res.data,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { onSubmit } = this.props;
    const { detail } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;
        if (detail.uuid) {
          params.uuid = detail.uuid;
          params.levelCode = detail.levelCode;
        }
        onSubmit(values);
      }
    });
  };

  format = data => {
    data.map(item => {
      item.title = item.name;
      item.value = item.levelCode;
      item.key = item.levelCode;
      if (item.children) {
        this.format(item.children);
      }
      return item;
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      gData,
    } = this.props;
    const { detail } = this.state;
    const initDetail = this.props.detail;
    const parent = detail.parent || initDetail.parent;

    this.format(gData);
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    if (detail.uuid) {
      detail.parent = detail.levelCode.slice(0, detail.levelCode.length - 2);
    }
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15 }}>
          <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
            保存
          </Button>
        </div>
        <Row>
          <Col span={12}>
            <FormItem label="组织名称" {...ItemLayout}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入组织名称!' }],
                initialValue: detail.name,
              })(<Input placeholder="组织名称" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="组织简名" {...ItemLayout}>
              {getFieldDecorator('sort', {
                initialValue: detail.sort,
              })(<Input placeholder="组织简名" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="组织简拼" {...ItemLayout}>
              {getFieldDecorator('pinyin', {
                initialValue: detail.pinyin,
              })(<Input placeholder="组织简拼" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="上级组织" {...ItemLayout}>
              {getFieldDecorator('parent', {
                initialValue: parent,
              })(
                <TreeSelect
                  disabled={!!parent}
                  showSearch
                  treeNodeFilterProp="title"
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  treeData={gData}
                  treeDefaultExpandAll
                />,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="组织类型" {...ItemLayout}>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '请选择组织类型!' }],
                initialValue: detail.type,
              })(
                <RadioGroup>
                  <Radio value={2}>公司</Radio>
                  <Radio value={3}>部门</Radio>
                </RadioGroup>,
              )}
            </FormItem>
          </Col>
          <Col span={24}>
            <FormItem label="备注" {...ItemLayout2}>
              {getFieldDecorator('remark', {
                initialValue: detail.remark,
              })(<Input.TextArea rows={4} placeholder="备注" maxLength={1000} />)}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => ({ gData: state.organization }))(
  Form.create({ wrappedComponentRef: true })(FormOrg),
);



// WEBPACK FOOTER //
// ./src/components/hr/org/FormOrg.js